import { css } from 'styled-components'

export const inputs = {
  inputs: css`
    border-radius: 15px;
    font-size: 20px;
    letter-spacing: 1.5px;
    padding: 10px 20px;
    border-width: 2px;
    border-style: solid;
  `,
}
